import {
  BaseStepActions,
  BaseStepsActionTypes,
} from '@ordersnproducts/modules/new-modify-order/actions/base-stepper-actions';

// tslint:disable-next-line:no-empty-interface
export interface ModifyOrderState {
  activeStep: number;
  disableNavigation: boolean;
}

export const initialState: ModifyOrderState = {
  activeStep: null,
  disableNavigation: true,
};

export function reducer(state = initialState, action: BaseStepActions): ModifyOrderState {
  switch (action.type) {
    case BaseStepsActionTypes.SET_ACTIVE_STEP: {
      return {
        ...state,
        activeStep: action.payload,
      };
    }
    case BaseStepsActionTypes.DISABLE_NAVIGATION: {
      return {
        ...state,
        disableNavigation: action.payload,
      };
    }
    case BaseStepsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
